import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../../common/LoadingPanel";
import { dateConvert } from "../../common/Helpers";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { nahlasenieDodavkyController } from "../../../controllers/nahlaseniedodavky.controller";
import { Renderers } from "../../common/GridRowRenderer";

class NahlasenieDodavky extends Component {
    state = {
        items: [],
        loading: true,
        skip: 0,
        take: 25,
        selectedNahlasenieId: this.props.defaultSelectedNahlasenie,
        selectedIdDodavka: null
    };

    componentDidMount() {
        nahlasenieDodavkyController
            .getNahlasenieDodavky()
            .then((ajaxData) => {
                let data = JSON.parse(JSON.stringify(ajaxData), dateConvert);
                let selectedIndex = data.findIndex((x) => x.idnahlasenie === this.state.selectedNahlasenieId);
                this.setState({
                    items: data,
                    loading: false,
                    skip: this.changePageBySelectedDodavka(selectedIndex),
                    selectedIdDodavka: data[selectedIndex].iddodavka
                });
                this.props.changeSelectedNahlasenie(this.state.selectedNahlasenieId, data[selectedIndex].iddodavka, data[selectedIndex]);
                return data;
            })
            .then(() => {
                this.scrollToSelected();
            });
    }

    changePageBySelectedDodavka(selectedIndex) {
        return parseInt(selectedIndex / this.state.take, 10) * this.state.take;
    }

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    };

    scrollToSelected() {
        var divNahlasenieDodavky = document.getElementById("NahlasenieDodavky");
        if (divNahlasenieDodavky) {
            var container = divNahlasenieDodavky.getElementsByClassName("k-virtual-content");
            if (container) {
                var selectedElement = container[0].getElementsByClassName("k-state-selected");
                if (selectedElement) selectedElement[0].scrollIntoView({ behavior: "smooth", block: "end" });
            }
        }
    }

    gridRowEventHandler = (eventType, dataItem) => {
        if (eventType === "onDoubleClick") {
            this.props.openDetailDodavky(dataItem.iddodavka);
        }
    };

    renderTable(items) {
        var localizationService = provideLocalizationService(this);
        var renderers = new Renderers();

        return (
            <div id="NahlasenieDodavky" onMouseDown={(e) => e.preventDefault() /* prevents browser text selection */}>
                <Grid
                    data={items
                        .slice(this.state.skip, this.state.take + this.state.skip)
                        .map((item) => ({ ...item, selected: item.idnahlasenie === this.state.selectedNahlasenieId }))}
                    skip={this.state.skip}
                    take={this.state.take}
                    total={items.length}
                    pageable={true}
                    onPageChange={this.pageChange}
                    selectedField="selected"
                    onRowClick={(e) => {
                        this.setState({
                            selectedNahlasenieId: e.dataItem.idnahlasenie,
                            selectedIdDodavka: e.dataItem.iddodavka
                        });
                        this.props.changeSelectedNahlasenie(e.dataItem.idnahlasenie, e.dataItem.iddodavka, e.dataItem);
                    }}
                    rowRender={(trElement, dataItem) => renderers.rowRender(trElement, dataItem, this.gridRowEventHandler)}>
                    <GridColumn field="idnahlasenie2" title={localizationService.toLanguageString("NahlasenieDodavky.Grid.ID", "ID")} width="50px" />
                    <GridColumn field="nazov" title={localizationService.toLanguageString("NahlasenieDodavky.Grid.Odosielateľ", "Odosielateľ")} />
                    <GridColumn field="cisloDodavky" title={localizationService.toLanguageString("NahlasenieDodavky.Grid.Dodávka", "Dodávka")} width="60px" />
                    <GridColumn field="sposobDopravy" title={localizationService.toLanguageString("NahlasenieDodavky.Grid.Doprava", "Doprava")} />
                    <GridColumn field="pocetBalikov" title={localizationService.toLanguageString("NahlasenieDodavky.Grid.Balíkov", "Balíkov")} width="35px" />
                    <GridColumn field="sumOfPocetKs" title={localizationService.toLanguageString("NahlasenieDodavky.Grid.Ks", "Ks")} width="35px" />
                    <GridColumn
                        field="datum"
                        title={localizationService.toLanguageString("NahlasenieDodavky.Grid.Expedované", "Expedované")}
                        width="70px"
                        format="{0:d.M.yyyy}"
                    />
                    <GridColumn
                        field="balTextPotvrdenieStav"
                        title={localizationService.toLanguageString("NahlasenieDodavky.Grid.Stav B/L", "Stav B/L")}
                        width="70px"
                    />
                    <GridColumn
                        field="textPotvrdenieStav"
                        title={localizationService.toLanguageString("NahlasenieDodavky.Grid.Stav ks", "Stav ks")}
                        width="70px"
                    />
                    <GridColumn
                        field="datumNahlasenia"
                        title={localizationService.toLanguageString("NahlasenieDodavky.Grid.Nahlásené", "Nahlásené")}
                        format="{0:d.M.yyyy}"
                        width="70px"
                    />
                    <GridColumn field="nahlasilUzivatelMeno" title={localizationService.toLanguageString("NahlasenieDodavky.Grid.Nahlásil", "Nahlásil")} />
                </Grid>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderTable(this.state.items);

        return <div>{contents}</div>;
    }
}

export default NahlasenieDodavky;

registerForLocalization(NahlasenieDodavky);



// WEBPACK FOOTER //
// ./src/components/dialogs/NahlasenieDodavky/NahlasenieDodavky.js